import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { appSettingsKey } from 'src/utils/settings';

interface AppState {
  theme: 'dark' | 'light' | 'system';
  locale: 'vi' | 'en';
  zoom: number;
  fullscreen: boolean;
  sideNavExpanded: boolean;
  setTheme: (theme: 'dark' | 'light' | 'system') => void;
  setLocale: (locale: 'vi' | 'en') => void;
  setZoom: (zoom: number) => void;
  setFullscreen: (fullscreen: boolean) => void;
  setSideNavExpanded: (sideNavExpanded: boolean) => void;
}

export const useAppStore = create(
  persist<AppState>(
    (set) => ({
      theme: 'dark',
      locale: import.meta.env.VITE_DEFAULT_LOCALE || 'vi',
      zoom: 1,
      fullscreen: false,
      sideNavExpanded: false,
      setTheme: (theme: 'dark' | 'light' | 'system') => {
        set((state) => {
          return {
            ...state,
            theme,
          };
        });
      },
      setLocale: (locale: 'vi' | 'en') => {
        set((state) => {
          return {
            ...state,
            locale,
          };
        });
      },
      setZoom: (zoom: number) => {
        set((state) => {
          return {
            ...state,
            zoom,
          };
        });
      },
      setFullscreen: (fullscreen: boolean) => {
        set((state) => {
          return {
            ...state,
            fullscreen,
          };
        });
      },
      setSideNavExpanded: (sideNavExpanded: boolean) => {
        set((state) => ({ ...state, sideNavExpanded }));
      },
    }),
    {
      name: appSettingsKey,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) =>
        ({ theme: state.theme, locale: state.locale, zoom: state.zoom, fullscreen: state.fullscreen } as AppState),
    }
  )
);
